module.exports = __webpack_public_path__ + "static/buehne_ueber-uns-9f9b5da84a105e63d01b76211e3727d2.svg";